import { AddBusinessAdmin, BusinessAdmin } from '../../pages';
import { employeeStore, userStore } from '../../stores';
import React, { useState } from 'react';
import { toJS } from 'mobx';

const AddBusinessAdminContainer = ({ closeModal }) => {
	const [groupPermissions, setGroupPermissions] = useState(false);

	const allEmployees = toJS(employeeStore.employees.filter(employee => employee.status !== 'TERMINATED'));
	const allAdmins = toJS(employeeStore.businessAdmins);

	const employeeData = allEmployees.filter(
		x => !allAdmins.find(y => x.user._id === y.user._id)
	);

	const showGroupPermissions = employee => {
		userStore.setSelectedAdmin(employee);
		setGroupPermissions(true);
	};


	const [permissions, setPermissions] = useState('');

	const showPermissions = i => {
		if (permissions === i) {
			return setPermissions(' ');
		} else {
			setPermissions(i);
		}
	};

	return (
		<AddBusinessAdmin
			closeModal={closeModal}
			permissions={permissions}
			groupPermissions={groupPermissions}
			showGroupPermissions={showGroupPermissions}
			employeeData={employeeData}
			showPermissions={showPermissions}
		/>
	);
};

export default AddBusinessAdminContainer;
